import { useCurrentUserQuery } from '@/src/components/TeamDashboard/queries'

/**
 * Hook to get the current user's team ID from cached query data.
 * Returns undefined if the data hasn't loaded yet.
 */
export const useCurrentTeamId = (): string | undefined => {
  const { data: userData } = useCurrentUserQuery()
  return userData?.user?.current_team_id
}
